import download from 'downloadjs';

const handleDownload = async (url, options = {}) => {
  const { method = 'GET', payload, headers } = options;

  const response = await fetch(url, {
    method,
    headers: {
      Accept: '*/*',
      'Content-Type': 'application/json',
      ...headers,
    },
    body: method.toUpperCase() === 'GET' ? undefined : JSON.stringify(payload),
  });

  if (!response.ok) {
    let message = response.statusText;
    let info = { errors: [{ message }] };

    try {
      const text = await response.text();
      const json = JSON.parse(text);

      if (Array.isArray(json?.errors) && json.errors.length) {
        const uniqueMessages = [...new Set(json.errors.map(item => item?.message).filter(Boolean))];

        message = uniqueMessages.join('\r\n') || message;
        info = {
          ...json,
          errors: json.errors,
        };
      } else {
        message = json?.message || json?.error || text;
        info = {
          ...json,
          errors: [{ message }],
        };
      }
    } catch {
      // keep statusText as fallback
    }

    const error = new Error(message);
    error.status = response.status;
    error.info = info;
    throw error;
  }

  const blob = await response.blob();

  if (typeof document !== 'undefined') {
    const contentDisposition = response.headers.get('content-disposition');
    const filenameMatch = contentDisposition?.match(/filename="(.*)"/);
    const filename = filenameMatch ? filenameMatch[1] : 'download';
    download(blob, filename, blob.type);
  }
};

export default handleDownload;
